import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tz"];
import { Component } from 'react';
import partial from 'react-utils/partial';
import { attachWrappedComponent } from '../../../utils/decoratorUtils/decoratorUtils';
import { equals, now } from '../../../utils/SimpleDate';
import { jsx as _jsx } from "react/jsx-runtime";
export const instancesForTz = {
  userTz: [],
  portalTz: [],
  utc: []
};
const todayForTz = {
  userTz: undefined,
  portalTz: undefined,
  utc: undefined
};
const intervalHandleForTz = {};
const updateToday = tz => {
  const oldToday = todayForTz[tz];
  const newToday = now(tz);
  if (!oldToday || !equals(oldToday, newToday)) {
    todayForTz[tz] = newToday;
    instancesForTz[tz].forEach(instance => instance.forceUpdate());
  }
};
const registerInstance = (instance, tz) => {
  if (!instancesForTz[tz]) instancesForTz[tz] = [];
  const instances = instancesForTz[tz];
  if (instances.indexOf(instance) >= 0) {
    return;
  }
  instances.push(instance);
  if (instances.length === 1) {
    updateToday(tz);
    intervalHandleForTz[tz] = setInterval(partial(updateToday, tz), 60e3);
  }
};
const unregisterInstance = (instance, tz) => {
  const instances = instancesForTz[tz];
  const index = instances.indexOf(instance);
  if (index >= 0) instances.splice(index, 1);
  if (instances.length === 0 && intervalHandleForTz[tz]) {
    clearInterval(intervalHandleForTz[tz]);
    delete intervalHandleForTz[tz];
  }
};
export const UsesToday = WrappedComponent => {
  class UsesTodayComponent extends Component {
    componentDidMount() {
      const tz = this.props.tz || 'userTz';
      registerInstance(this, tz);
    }
    componentDidUpdate(prevProps) {
      const oldTz = prevProps.tz || 'userTz';
      const newTz = this.props.tz || 'userTz';
      if (oldTz !== newTz) {
        unregisterInstance(this, oldTz);
        registerInstance(this, newTz);
      }
    }
    componentWillUnmount() {
      const tz = this.props.tz || 'userTz';
      unregisterInstance(this, tz);
    }
    render() {
      const _this$props = this.props,
        {
          tz = 'userTz'
        } = _this$props,
        restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        today: todayForTz[tz]
      }, restProps));
    }
  }
  attachWrappedComponent(UsesTodayComponent, WrappedComponent);
  return UsesTodayComponent;
};